var _circle, _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#B2B2B2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_719_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9287 35.8947C49.3176 35.8947 49.3176 33.5 49.3176 33.5C49.3176 33.5 49.3176 31.1053 46.9287 31.1053C44.5398 31.1053 44.5398 32.1774 44.5398 33.5C44.5398 34.8226 44.5398 35.8947 46.9287 35.8947Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.27 30.421C50.0001 30.421 50.0001 27.6842 50.0001 27.6842C50.0001 27.6842 50.0001 24.9474 47.27 24.9474C44.5398 24.9474 44.5398 26.1727 44.5398 27.6842C44.5398 29.1957 44.5398 30.421 47.27 30.421Z",
    fill: "#CBCBCB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_719_951)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4444 14C43.8571 14 45.9047 16.0526 45.9047 19.4737V25.6316C45.9047 27.5148 45.2842 28.9833 44.1571 29.9231C45.1778 30.7119 45.9047 31.9349 45.9047 33.1579C45.9047 37.2632 43.1746 40 39.0793 40H13.1428C11.4365 40 11.0952 39.6579 11.0952 37.9474V31.1053V29.0526V20.8421C11.0952 16.7368 13.8254 14 17.9206 14H40.4444Z",
    fill: "#F2F2F2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_719_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7619 32.4737H21.3333C19.9684 32.4737 19.9683 32.8158 19.9683 33.5C19.9683 34.1842 20.6508 35.2105 24.746 35.2105H36.3492C40.4444 35.2105 41.127 34.1842 41.127 33.5C41.127 32.8158 41.1268 32.4737 39.7619 32.4737Z",
    fill: "#BEBEBE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_719_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6507 16.0526H40.4444C42.492 16.0526 43.8571 18.1052 43.8571 20.1579V24.9473C43.8571 27 42.492 29.0526 40.4444 29.0526H20.6507C18.6031 29.0526 17.238 27 17.238 24.9473V20.1579C17.238 18.1052 18.6031 16.0526 20.6507 16.0526Z",
    fill: "#BEBEBE"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_719_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7461 26.3158C27.0079 26.3158 28.8414 24.4778 28.8414 22.2105C28.8414 19.9432 27.0079 18.1053 24.7461 18.1053C22.4844 18.1053 20.6509 19.9432 20.6509 22.2105C20.6509 24.4778 22.4844 26.3158 24.7461 26.3158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7144 26.3158C39.9761 26.3158 41.8096 24.4778 41.8096 22.2105C41.8096 19.9432 39.9761 18.1053 37.7144 18.1053C35.4526 18.1053 33.6191 19.9432 33.6191 22.2105C33.6191 24.4778 35.4526 26.3158 37.7144 26.3158Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_719_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0715 35.8947C12.4604 35.8947 12.4604 34.8226 12.4604 33.5C12.4604 32.1774 12.4604 31.1053 10.0715 31.1053C7.68262 31.1053 7.68262 33.5 7.68262 33.5C7.68262 33.5 7.68262 35.8947 10.0715 35.8947Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73016 30.421C12.4603 30.421 12.4603 29.1957 12.4603 27.6842V27.6842C12.4603 26.1727 12.4603 24.9474 9.73016 24.9474C7 24.9474 7 27.6842 7 27.6842C7 27.6842 7 30.421 9.73016 30.421Z",
    fill: "#CBCBCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_719_951",
    x: 39.5398,
    y: 21.9474,
    width: 13.4602,
    height: 18.9474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_719_951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_719_951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_719_951",
    x: 6.09521,
    y: 11,
    width: 42.8096,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_719_951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_719_951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_719_951",
    x: 19.9683,
    y: 32.4737,
    width: 21.1587,
    height: 2.73685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_719_951"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_719_951",
    x: 17.238,
    y: 16.0526,
    width: 26.6191,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_719_951"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_719_951",
    x: 12.6509,
    y: 10.1053,
    width: 37.1587,
    height: 24.2105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_719_951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_719_951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_719_951",
    x: 2,
    y: 21.9474,
    width: 13.4604,
    height: 18.9474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_719_951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_719_951",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg09);
export default __webpack_public_path__ + "static/media/09.a983bf04f4a655639fcd49954ffa1bd6.svg";
export { ForwardRef as ReactComponent };